import { Component, Input } from '@angular/core';
import { Column } from '@shared/models';

@Component({
  selector: 'gcc-grid-cell',
  templateUrl: './grid-cell.component.html',
  styleUrls: ['./grid-cell.component.scss'],
  standalone: false
})
export class GridCellComponent {
  @Input() public column: Column.GridColumn;
  @Input() public item: Record<string, any>;
  @Input() public highlight: string;

  public columnTypes = Column.ColumnType;

  constructor() {}
}
